import React from 'react';
export const DateDisplay = ({ className, locale, value }) => {
    const dateString = new Date(value).toLocaleDateString(locale);
    return (React.createElement("time", { suppressHydrationWarning: true, className: className, dateTime: value }, dateString));
};
